import styled from 'styled-components'

const FormContainer = styled.div`
  max-width: 600px;
  margin: auto;
`

export { FormContainer }
